/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import byIdSaga from './byId';
import createSaga from './create';
import updateSaga from './update';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { PaginatedResponse } from '../types';

export const moduleName = 'tag';

export type TagStatus = 'published' | 'deactivated' | 'draft';
export const TagStatusTitle: Record<TagStatus, string> = {
  published: 'Published',
  deactivated: 'Deactivated',
  draft: 'Draft',
};
export interface Tag {
  id: string;
  name: string;
  color?: string;
}

export interface TagFile {
  id: string;
  originalName: string;
  location: string;
  mimeType: string;
  createdAt: string;
}

export interface State {
  list: BaseState<PaginatedResponse<Tag>>,
  byId: BaseState<Tag>,
  create: BaseState<{ id: string }>,
  update: BaseState<Tag>,
  delete: BaseState<{ id: string }>
}

const models = ['list', 'byId', 'create', 'update', 'delete'];

export const defaultState: State = createCRUDStates<State>(models);

export const tag = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = tag;

export function useTag(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* byIdSaga();
  yield* createSaga();
  yield* updateSaga();
}
